import(/* webpackMode: "eager", webpackExports: ["Cards"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/honorees/components/cards.tsx");
